// extracted by mini-css-extract-plugin
module.exports = {"selectedBox":"comeInList_selectedBox__3gN_e","tableList":"comeInList_tableList__3J5WT"};